export default __webpack_public_path__ + "static/media/planeAsset 5.59b12f36.svg";